import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useLangContext } from "../../context/langContext";

import PaymentTableComponent from "../../components/panel/payments/PaymentTable";
import PaymentCreateModal from "../../components/panel/payments/modal/PaymentCreateModal";
import { GatewaySchema } from "../../services/Schemas/Gateway";
import { AccessEnums } from "../../constants/accessEnum";
import { useCanAccess } from "../../hooks/canAccess";

const compInfos = {
  en: {
    title: "Contacts",
    subtitle: "Your Contacts list",
    buttonOne: "upload phone's file",
  },
  fa: {
    title: "درگاه های پرداخت",
    subtitle: "لیست درگاه های پرداخت",
    buttonOne: "ایجاد درگاه جدید",
  },
};

export default function PaymentsPage() {
  const { lang } = useLangContext();
  const [openModal, setOpenModal] = useState(false);

  const infos = compInfos[lang];
  const [walletReload, setWalletReload] = useState<boolean>(false);
  const [serverInfo, setServerInfo] = useState<GatewaySchema | undefined>(
    undefined
  );
  const { can } = useCanAccess();

  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={(theme) => theme.palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                {infos.title}
              </Typography>
              <Typography
                variant="footerDemiBold"
                sx={{
                  mb: "20px",
                  color: ({ palette }) => palette.complement[300],
                }}
              >
                {infos.subtitle}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
            >
              <Button
                onClick={() => setOpenModal(true)}
                variant="contained"
                disabled={!can(AccessEnums.AdminPaymentGatewayCreate)}
              >
                {infos.buttonOne}
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <PaymentTableComponent
          walletReload={walletReload}
          setWalletReload={setWalletReload}
          setServerInfo={setServerInfo}
          setOpenModal={setOpenModal}
        />
      </Stack>
      <PaymentCreateModal
        onCloseModal={() => {
          setOpenModal(false);
          setServerInfo(undefined);
        }}
        openModal={openModal}
        serverInfo={serverInfo}
        handleReload={() => setWalletReload(!walletReload)}
      />
    </>
  );
}
